import { cn } from "@/lib/utils";
import { statisticsSidebarSurfaceCardClassName } from "../Statistics/components/statisticsShadcnCardShell";

export const strategyRdMainCardClassName = cn(
  "flex w-full min-w-0 flex-col gap-4 rounded-[6px] border border-border bg-card p-4 text-card-foreground shadow-none",
  statisticsSidebarSurfaceCardClassName
);

export const strategyRdSectionTitleClassName =
  "font-[family-name:var(--font-primary)] text-base font-medium text-[color:var(--brand-tropical-surf)]";

export const strategyRdMetaClassName =
  "font-[family-name:var(--font-primary)] text-sm text-gray-500 dark:text-sidebar-foreground";

/**
 * Layout helpers for `variant="outline-brand"` actions.
 * Do not pair with `variant="outline"` — its inline greys override brand stroke.
 */
export const strategyRdBrandIconButtonClassName = "size-8 shrink-0 shadow-none";

/** Labeled icon actions — Add / Edit (use with outline-brand + size sm). */
export const strategyRdBrandActionButtonClassName = cn(
  "h-8 gap-1.5 px-2.5 shadow-none",
  "font-[family-name:var(--font-primary)]"
);

/** Tall enough to explore price + drawings; Preview click frames ~40 candles. */
export const STRATEGY_RD_CHART_HEIGHT = 620;
